// ============================================
// COUNTRY CODES DATA (ДАННЫЕ КОДОВ СТРАН)
// ============================================

// Функция для получения emoji флага страны по ISO коду (fallback)
window.getCountryFlagEmoji = function(countryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
};

// Данные стран с кодами, флагами и паттернами валидации
// flag: 'emoji' — используем Unicode emoji (🇷🇺). Для Windows нужен country-flag-emoji-polyfill
// Формат паттерна: { min: минимальная длина, max: максимальная длина, regex: регулярное выражение }
const countryCodesData = [
  // Приоритетные страны (Россия и Узбекистан в начале)
  { code: '+7', country: 'ru', name: 'Россия', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '999 999 99 99' },
  { code: '+998', country: 'uz', name: 'Узбекистан', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '99 999 99 99' },
  
  // Остальные страны (отсортированы по коду)
  { code: '+1', country: 'us', name: 'США', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '(999) 999-9999' },
  { code: '+1', country: 'ca', name: 'Канада', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '(999) 999-9999' },
  { code: '+20', country: 'eg', name: 'Египет', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '100 123 4567' },
  { code: '+27', country: 'za', name: 'ЮАР', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '82 123 4567' },
  { code: '+30', country: 'gr', name: 'Греция', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '691 234 5678' },
  { code: '+31', country: 'nl', name: 'Нидерланды', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '6 12345678' },
  { code: '+32', country: 'be', name: 'Бельгия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '470 12 34 56' },
  { code: '+33', country: 'fr', name: 'Франция', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '6 12 34 56 78' },
  { code: '+34', country: 'es', name: 'Испания', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '612 34 56 78' },
  { code: '+36', country: 'hu', name: 'Венгрия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '20 123 4567' },
  { code: '+39', country: 'it', name: 'Италия', flag: 'emoji', pattern: { min: 9, max: 10, regex: /^[0-9]{9,10}$/ }, placeholder: '312 345 6789' },
  { code: '+40', country: 'ro', name: 'Румыния', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '712 345 678' },
  { code: '+41', country: 'ch', name: 'Швейцария', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '78 123 45 67' },
  { code: '+43', country: 'at', name: 'Австрия', flag: 'emoji', pattern: { min: 10, max: 13, regex: /^[0-9]{10,13}$/ }, placeholder: '664 123456' },
  { code: '+44', country: 'gb', name: 'Великобритания', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '7700 900000' },
  { code: '+45', country: 'dk', name: 'Дания', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '20 12 34 56' },
  { code: '+46', country: 'se', name: 'Швеция', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '70 123 45 67' },
  { code: '+47', country: 'no', name: 'Норвегия', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '123 45 678' },
  { code: '+48', country: 'pl', name: 'Польша', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '512 345 678' },
  { code: '+49', country: 'de', name: 'Германия', flag: 'emoji', pattern: { min: 10, max: 11, regex: /^[0-9]{10,11}$/ }, placeholder: '151 23456789' },
  { code: '+51', country: 'pe', name: 'Перу', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '987 654 321' },
  { code: '+52', country: 'mx', name: 'Мексика', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '55 1234 5678' },
  { code: '+54', country: 'ar', name: 'Аргентина', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '11 1234-5678' },
  { code: '+55', country: 'br', name: 'Бразилия', flag: 'emoji', pattern: { min: 10, max: 11, regex: /^[0-9]{10,11}$/ }, placeholder: '11 91234-5678' },
  { code: '+56', country: 'cl', name: 'Чили', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '9 1234 5678' },
  { code: '+57', country: 'co', name: 'Колумбия', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '300 123 4567' },
  { code: '+60', country: 'my', name: 'Малайзия', flag: 'emoji', pattern: { min: 9, max: 10, regex: /^[0-9]{9,10}$/ }, placeholder: '12-345 6789' },
  { code: '+61', country: 'au', name: 'Австралия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '412 345 678' },
  { code: '+62', country: 'id', name: 'Индонезия', flag: 'emoji', pattern: { min: 9, max: 11, regex: /^[0-9]{9,11}$/ }, placeholder: '812 345 6789' },
  { code: '+63', country: 'ph', name: 'Филиппины', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '917 123 4567' },
  { code: '+64', country: 'nz', name: 'Новая Зеландия', flag: 'emoji', pattern: { min: 8, max: 10, regex: /^[0-9]{8,10}$/ }, placeholder: '21 123 4567' },
  { code: '+65', country: 'sg', name: 'Сингапур', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '9123 4567' },
  { code: '+66', country: 'th', name: 'Таиланд', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '81 234 5678' },
  { code: '+81', country: 'jp', name: 'Япония', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '90 1234 5678' },
  { code: '+82', country: 'kr', name: 'Южная Корея', flag: 'emoji', pattern: { min: 9, max: 10, regex: /^[0-9]{9,10}$/ }, placeholder: '10 1234 5678' },
  { code: '+84', country: 'vn', name: 'Вьетнам', flag: 'emoji', pattern: { min: 9, max: 10, regex: /^[0-9]{9,10}$/ }, placeholder: '91 234 5678' },
  { code: '+86', country: 'cn', name: 'Китай', flag: 'emoji', pattern: { min: 11, max: 11, regex: /^[0-9]{11}$/ }, placeholder: '138 0013 8000' },
  { code: '+90', country: 'tr', name: 'Турция', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '532 123 45 67' },
  { code: '+91', country: 'in', name: 'Индия', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '98765 43210' },
  { code: '+92', country: 'pk', name: 'Пакистан', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '300 1234567' },
  { code: '+93', country: 'af', name: 'Афганистан', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '70 123 4567' },
  { code: '+94', country: 'lk', name: 'Шри-Ланка', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '71 234 5678' },
  { code: '+95', country: 'mm', name: 'Мьянма', flag: 'emoji', pattern: { min: 8, max: 10, regex: /^[0-9]{8,10}$/ }, placeholder: '9 123 456 789' },
  { code: '+212', country: 'ma', name: 'Марокко', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '612 345 678' },
  { code: '+213', country: 'dz', name: 'Алжир', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '551 23 45 67' },
  { code: '+216', country: 'tn', name: 'Тунис', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '20 123 456' },
  { code: '+221', country: 'sn', name: 'Сенегал', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '70 123 45 67' },
  { code: '+233', country: 'gh', name: 'Гана', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '24 123 4567' },
  { code: '+234', country: 'ng', name: 'Нигерия', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '802 123 4567' },
  { code: '+250', country: 'rw', name: 'Руанда', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '788 123456' },
  { code: '+254', country: 'ke', name: 'Кения', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '712 123456' },
  { code: '+255', country: 'tz', name: 'Танзания', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '712 345678' },
  { code: '+256', country: 'ug', name: 'Уганда', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '712 345678' },
  { code: '+351', country: 'pt', name: 'Португалия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '912 345 678' },
  { code: '+352', country: 'lu', name: 'Люксембург', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '621 123 456' },
  { code: '+353', country: 'ie', name: 'Ирландия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '85 123 4567' },
  { code: '+354', country: 'is', name: 'Исландия', flag: 'emoji', pattern: { min: 7, max: 7, regex: /^[0-9]{7}$/ }, placeholder: '612 3456' },
  { code: '+355', country: 'al', name: 'Албания', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '67 123 4567' },
  { code: '+356', country: 'mt', name: 'Мальта', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '9912 3456' },
  { code: '+357', country: 'cy', name: 'Кипр', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '99 123456' },
  { code: '+358', country: 'fi', name: 'Финляндия', flag: 'emoji', pattern: { min: 6, max: 10, regex: /^[0-9]{6,10}$/ }, placeholder: '50 123 4567' },
  { code: '+359', country: 'bg', name: 'Болгария', flag: 'emoji', pattern: { min: 8, max: 9, regex: /^[0-9]{8,9}$/ }, placeholder: '888 123 456' },
  { code: '+370', country: 'lt', name: 'Литва', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '612 34567' },
  { code: '+371', country: 'lv', name: 'Латвия', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '21 234 567' },
  { code: '+372', country: 'ee', name: 'Эстония', flag: 'emoji', pattern: { min: 7, max: 8, regex: /^[0-9]{7,8}$/ }, placeholder: '5123 4567' },
  { code: '+373', country: 'md', name: 'Молдова', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '6912 3456' },
  { code: '+374', country: 'am', name: 'Армения', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '91 123456' },
  { code: '+375', country: 'by', name: 'Беларусь', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '29 123-45-67' },
  { code: '+380', country: 'ua', name: 'Украина', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '50 123 4567' },
  { code: '+381', country: 'rs', name: 'Сербия', flag: 'emoji', pattern: { min: 8, max: 9, regex: /^[0-9]{8,9}$/ }, placeholder: '60 123 4567' },
  { code: '+382', country: 'me', name: 'Черногория', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '67 123 456' },
  { code: '+385', country: 'hr', name: 'Хорватия', flag: 'emoji', pattern: { min: 8, max: 9, regex: /^[0-9]{8,9}$/ }, placeholder: '91 123 4567' },
  { code: '+386', country: 'si', name: 'Словения', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '31 234 567' },
  { code: '+387', country: 'ba', name: 'Босния и Герцеговина', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '61 123 456' },
  { code: '+389', country: 'mk', name: 'Северная Македония', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '72 123 456' },
  { code: '+420', country: 'cz', name: 'Чехия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '601 123 456' },
  { code: '+852', country: 'hk', name: 'Гонконг', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '9123 4567' },
  { code: '+853', country: 'mo', name: 'Макао', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '6612 3456' },
  { code: '+880', country: 'bd', name: 'Бангладеш', flag: 'emoji', pattern: { min: 10, max: 10, regex: /^[0-9]{10}$/ }, placeholder: '1712 345678' },
  { code: '+886', country: 'tw', name: 'Тайвань', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '912 345 678' },
  { code: '+961', country: 'lb', name: 'Ливан', flag: 'emoji', pattern: { min: 7, max: 8, regex: /^[0-9]{7,8}$/ }, placeholder: '3 123 456' },
  { code: '+962', country: 'jo', name: 'Иордания', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '7 1234 5678' },
  { code: '+965', country: 'kw', name: 'Кувейт', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '5012 3456' },
  { code: '+966', country: 'sa', name: 'Саудовская Аравия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '50 123 4567' },
  { code: '+968', country: 'om', name: 'Оман', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '9212 3456' },
  { code: '+971', country: 'ae', name: 'ОАЭ', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '50 123 4567' },
  { code: '+972', country: 'il', name: 'Израиль', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '50 123 4567' },
  { code: '+973', country: 'bh', name: 'Бахрейн', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '3612 3456' },
  { code: '+974', country: 'qa', name: 'Катар', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '3312 3456' },
  { code: '+992', country: 'tj', name: 'Таджикистан', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '917 123456' },
  { code: '+993', country: 'tm', name: 'Туркменистан', flag: 'emoji', pattern: { min: 8, max: 8, regex: /^[0-9]{8}$/ }, placeholder: '61 12 34 56' },
  { code: '+994', country: 'az', name: 'Азербайджан', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '50 123 45 67' },
  { code: '+995', country: 'ge', name: 'Грузия', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '555 123456' },
  { code: '+996', country: 'kg', name: 'Кыргызстан', flag: 'emoji', pattern: { min: 9, max: 9, regex: /^[0-9]{9}$/ }, placeholder: '700 123456' },
];

// Страны уже отсортированы в массиве: сначала Россия и Узбекистан, затем остальные по коду
// Дополнительная сортировка не требуется

// Экспортируем данные
window.countryCodesData = countryCodesData;

// Функция для получения данных страны по коду
function getCountryByCode(code) {
  return countryCodesData.find(country => country.code === code);
}

// Функция для получения данных страны по ISO коду
function getCountryByISO(iso) {
  return countryCodesData.find(country => country.country === iso);
}

// Функция для валидации номера телефона
function validatePhoneNumber(phoneNumber, countryCode) {
  const country = getCountryByCode(countryCode);
  if (!country) return { valid: false, message: 'Неизвестный код страны' };
  
  // Убираем все пробелы и дефисы для проверки
  const cleanNumber = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
  // Проверяем длину
  if (cleanNumber.length < country.pattern.min || cleanNumber.length > country.pattern.max) {
    return { 
      valid: false, 
      message: `Номер должен содержать от ${country.pattern.min} до ${country.pattern.max} цифр` 
    };
  }
  
  // Проверяем паттерн
  if (!country.pattern.regex.test(cleanNumber)) {
    return { 
      valid: false, 
      message: `Неверный формат номера для ${country.name}` 
    };
  }
  
  return { valid: true, message: '' };
}

function tokenizePhonePlaceholder(placeholder) {
  const normalized = String(placeholder || '').trim();
  if (!normalized) return [];
  return normalized.match(/\d+|\D+/g) || [];
}

function formatPhoneValueByPlaceholder(digits, placeholder, maxDigits) {
  const limitedDigits = String(digits || '').replace(/\D/g, '').slice(0, maxDigits);
  if (!limitedDigits) return '';

  const tokens = tokenizePhonePlaceholder(placeholder);
  if (!tokens.length) {
    return limitedDigits.replace(/(\d{3})(?=\d)/g, '$1 ');
  }

  let result = '';
  let digitIndex = 0;

  tokens.forEach(token => {
    if (digitIndex >= limitedDigits.length) return;

    if (/^\d+$/.test(token)) {
      const remaining = limitedDigits.length - digitIndex;
      const take = Math.min(token.length, remaining);
      result += limitedDigits.slice(digitIndex, digitIndex + take);
      digitIndex += take;
      return;
    }

    result += token;
  });

  if (digitIndex < limitedDigits.length) {
    result += limitedDigits.slice(digitIndex);
  }

  return result;
}

// Функция для форматирования номера телефона в зависимости от страны
function formatPhoneNumber(value, countryCode) {
  const country = getCountryByCode(countryCode);
  if (!country) {
    // Если страна не найдена, используем простое форматирование
    return value.replace(/(\d{3})(?=\d)/g, '$1 ');
  }
  
  const maxDigits = country.pattern.max;
  if (country.placeholder) {
    return formatPhoneValueByPlaceholder(value, country.placeholder, maxDigits);
  }

  // Если шаблона нет, используем простое форматирование
  const digitsOnly = String(value || '').replace(/\D/g, '').slice(0, maxDigits);
  return digitsOnly.replace(/(\d{3})(?=\d)/g, '$1 ');
}

// Функция для получения максимальной длины с учетом форматирования
function getMaxFormattedLength(countryCode) {
  const country = getCountryByCode(countryCode);
  if (!country) return 20; // По умолчанию

  const maxDigits = country.pattern.max;
  if (country.placeholder) {
    const tokens = tokenizePhonePlaceholder(country.placeholder);
    let remaining = maxDigits;
    let length = 0;

    tokens.forEach(token => {
      if (remaining <= 0) return;

      if (/^\d+$/.test(token)) {
        const take = Math.min(token.length, remaining);
        length += take;
        remaining -= take;
        return;
      }

      length += token.length;
    });

    if (remaining > 0) {
      length += remaining;
    }

    return length;
  }

  // Если шаблона нет, оставляем старую оценку
  return maxDigits + Math.floor(maxDigits / 3);
}

// Экспортируем функции
window.getCountryByCode = getCountryByCode;
window.getCountryByISO = getCountryByISO;
window.validatePhoneNumber = validatePhoneNumber;
window.formatPhoneNumber = formatPhoneNumber;
window.getMaxFormattedLength = getMaxFormattedLength;
